<template>
<section>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Evenements</h1>
    </div>
    <div class="container d-flex justify-content-between  mb-5 ">
      <button type="button" class="btn btn-add" v-on:click="AddAction">Ajouter evenement</button>
        <select type="text" v-model="type" class="form-control" style="width: 200px" @change="changeType">
            <option value="all">All</option>
            <option value="event">Event</option>
            <option value="teamBuilding">Team building</option>
        </select>
    </div>
    <div v-if="!showAddForm && !showUpdateForm" class=" container d-flex justify-content-between flex-wrap" >
      <EventCard :key="index" v-for=" (event , index) in this.events " :event=event  @update="updateAction"  @refresh="getData" />
    </div>
    <AddEvent v-if="showAddForm" @toggle="AddAction" @cancel="getData" @refresh="getData" />
    <UpdateEvent v-if="showUpdateForm"  :event="this.toUpdate" @refresh="getData" @cancel="getData"/>
</section>
</template>
<script>
import EventCard from './components/event/EventCard.vue';
import AddEvent from './components/event/AddEvent.vue';
import UpdateEvent from './components/event/UpdateEvent.vue';
import axios from "axios";
import APIs from "@/../config";
export default {
    name: "Event",
    data() {
        return {
            allData : [] , 
            type : "all" , 
            events: [] , 
            showAddForm : false, 
            showUpdateForm : false,
            toUpdate : {}
        };
    },
    components : {AddEvent , UpdateEvent, EventCard} , 
    created(){
        this.getData()
    },
    methods : {
        getData(){
          axios.get(`${APIs.API_URL}/event/`)
          .then(res => {
              this.events = res.data
              this.allData = res.data
          }).catch(error => {
              console.error(error)
          })
          this.showAddForm = this.showUpdateForm = false
          console.log(this.showAddForm , this.showUpdateForm)
        },
        changeType(){
            if(this.type !== 'all')
                this.events  = this.allData.filter(elt => elt.type == this.type && elt)
            else 
                this.events = this.allData
        },
        AddAction(){
            this.showAddForm = !this.showAddForm
            if(this.showUpdateForm)
                this.showUpdateForm = !this.showUpdateForm
        },
        updateAction(blog){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = blog
        },
    }
}
</script>

<style lang="scss" scoped>
.title{
    color:white;
}
.btn-light{
    background-color: black;
    color: white;
}
.btn-primary{
    background-color:white;
    color:#A68D5B;
    &:hover{
        background:white;
        color:#A68D5B;
    }
}



select{
    height: 35px;
    outline: none;
}
.boxs{
    display: flex;
    justify-content: space-around;
    width: 98%;
    margin-left: 3%;
    .box{
        background-color: rgb(236, 236, 236);
        height: 180px;
        width: 290px;
        border-radius: 10px;
        cursor:pointer;
        .buttons{
            top: 60%;
            position: relative;
            display: flex;
            justify-content: space-around;
            .btn-light{
                background-color:rgb(236, 236, 236) ;
                color: rgb(236, 236, 236);
                box-shadow: none;
            }
        }
    }
    :hover{
        background:rgb(236, 236, 236);
        .buttons{
            .btn-light{
                background-color:#A68D5B ;
                color: white
            }
        }
    }
}

</style>


<!-- if this .selected=='E' -->